import {HoistService, InitContext, XH} from '@xh/hoist/core';
import {RzxAuthModel} from '../../core/RzxAuthModel';

export class EntitlementService extends HoistService {
    private appRoles: string[] = [];

    override async initAsync(ctx: InitContext) {
        this.appRoles = (<RzxAuthModel>XH.authModel).roles;
    }

    /** A shadow user sees another user's portfolios read-only: the UI offers no orders, imports or deposit changes. */
    get isShadow(): boolean {
        return (<RzxAuthModel>XH.authModel).isShadow;
    }

    hasRole(role: string): boolean {
        return this.appRoles.includes(role);
    }
}
